<template>
    
    <div class="row">

        <div class="col-md-4">
            <!-- Form Input -->
            <div class="form-group">
                <label for="nota_trabajo_escrito">Nota Trabajo Escrito</label>
                <input type="number" class="form-control" min="0" max="100" name="nota_trabajo_escrito" placeholder="Nota trabajo escrito" v-model="nota_trabajo_escrito" @change="NotaFinal">
            </div>
        </div>

        <div class="col-md-4">
            <!-- Form Input -->
            <div class="form-group">
                <label for="nota_examen">Nota Examen</label>
                <input type="number" class="form-control" min="0" max="100" name="nota_examen" placeholder="Nota examen" v-model="nota_examen" @change="NotaFinal">
            </div>
        </div>

        <div class="col-md-4">
            <!-- Form Input -->
            <div class="form-group">
                <label for="nota_final">Nota Final</label>
                <input type="number" class="form-control" min="0" max="100" name="nota_final" placeholder="Nota final" v-model="nota_final">
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        data() {
            return {
                nota_trabajo_escrito: null,
                nota_examen: null,
                nota_final: null,
            }
        },
        props: {
            prop_nota_trabajo_escrito: {required: false, default: 0},
            prop_nota_examen: {required: false, defatul: 0},
            prop_nota_final: {required: false, defatul: 0},
        },
        mounted() {
            if(this.prop_nota_trabajo_escrito)
                this.nota_trabajo_escrito = this.prop_nota_trabajo_escrito;
            if(this.prop_nota_examen)
                this.nota_examen = this.prop_nota_examen;

            this.NotaFinal(this.prop_nota_final);
        },
        methods: {
            NotaFinal(nota_final) {
                if(this.nota_trabajo_escrito && this.nota_examen)
                    this.nota_final = Math.ceil((parseInt(this.nota_trabajo_escrito) + parseInt(this.nota_examen)) / 2);
                else
                    this.nota_final = nota_final;
            }
        }
    }
</script>